import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Wind, HeartPulse } from "lucide-react";
import SoulHero from "@/components/soul/SoulHero";
import SoulPracticeCard from "@/components/soul/SoulPracticeCard";
import SoulBreadcrumb from "@/components/soul/SoulBreadcrumb";
import { REGULATION_PRACTICES } from "@/pages/soul/soulContent";
import { HERO } from "@/lib/heroImages";

const ICONS = { breath: Wind, body: HeartPulse };

export default function RegulationPresence() {
  const nav = useNavigate();
  return (
    <div className="space-y-12" data-testid="soul-regulation-presence">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <SoulBreadcrumb
          items={[
            { label: "Rituals", to: "/rituals" },
            { label: "Soul", to: "/soul" },
            { label: "Regulation & Presence" },
          ]}
        />
        <button
          type="button"
          onClick={() => nav("/soul")}
          data-testid="soul-regulation-back"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--copper))] transition-colors"
        >
          <ArrowLeft size={12} /> Back to Soul
        </button>
      </div>

      <SoulHero
        emblem=""
        eyebrow="Soul · Regulation & Presence"
        title="Come back to yourself."
        supporting="Before we understand everything, sometimes we simply need a way back to the present."
        image={HERO.regulation}
        testid="soul-regulation-hero"
      />

      <section
        className="reveal reveal-1 grid gap-8 md:grid-cols-2"
        data-testid="soul-regulation-cards"
      >
        {REGULATION_PRACTICES.map((p) => (
          <SoulPracticeCard
            key={p.slug}
            title={p.title}
            tagline={p.tagline}
            image={p.image}
            to={`/soul/regulation-presence/${p.slug}`}
            Icon={ICONS[p.icon]}
            disabled={p.comingSoon}
            disabledLabel="Arriving soon"
            testid={`soul-regulation-${p.slug}`}
          />
        ))}
      </section>

      <section
        className="p-8 md:p-12 rounded-[24px] border hairline bg-[hsl(var(--paper))]"
        data-testid="soul-regulation-note"
      >
        <p className="font-display italic text-xl md:text-2xl text-[hsl(var(--fg))]/85 leading-snug max-w-3xl">
          Two doorways back to the present. Breath uses the rhythm you already have. Nervous System
          teaches you the language your body has been speaking all along.
        </p>
      </section>
    </div>
  );
}
